import React from "react";
import { isMobile } from "react-device-detect";

const CustomRadio = ({
  title,
  description,
  checked,
  mostPopular,
  onClick,
  idToScroll,
}) => {
  return (
    <div
      className="rounded-md border px-8 py-6 cursor-pointer relative mb-6"
      style={{
        borderColor: checked === title ? "#011E41" : "rgb(209,213,219)",
      }}
      onClick={() => {
        onClick(title);
        isMobile &&
          document
            .getElementById(idToScroll)
            ?.scrollIntoView({ behavior: "smooth", block: "start" });
      }}
      aria-hidden="true"
    >
      {mostPopular && (
        <div
          className="text-white text-sm rounded-r-md rounded-bl-md py-2 px-5 absolute"
          style={{ background: "#011E41", top: -1, right: -1 }}
        >
          Mest populär
        </div>
      )}
      <div
        className={
          "text-lg text-main-600 mb-1" +
          (checked === title ? " font-semibold" : "")
        }
      >
        {title}
      </div>
      <div className="text-sm text-gray-500" style={{ lineHeight: "24px" }}>
        {description}
      </div>
    </div>
  );
};

export default CustomRadio;
